import * as R from 'ramda'
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar'
import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { animated, useTransition } from 'react-spring'
import styled, { css } from 'styled-components'

import IconNextSvg from '../../public/static/images/icon-next.svg'
import IconPrevSvg from '../../public/static/images/icon-previous.svg'
import MaxWidth from '../Layout/MaxWidth'
import SvgIcon from '../SvgIcon'

const IconNext = styled(IconNextSvg)`
  width: 20px;
  height: 20px;
`
const IconPrev = styled(IconPrevSvg)`
  width: 20px;
  height: 20px;
`

// need higher specificity to override
const StyledScrollableInkTabBar = styled(animated(ScrollableInkTabBar))`
  && {
    .rc-tabs-ink-bar {
      height: 4px;
      border-radius: 2px;
    }
    ${({ $showFixedTabBar }) =>
      $showFixedTabBar &&
      css`
        &.rc-tabs-bar {
          border-bottom: none;
        }
        .rc-tabs-tab {
          height: 64px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }
      `}
  }
`
const AnimatedDiv = styled(animated.div)`
  z-index: 2;
  position: fixed;
  top: 0px;
  width: 100%;
  background-color: #fff;
  ${({ $showFixedTabBar }) =>
    $showFixedTabBar &&
    css`
      box-shadow: 0 2px 23px 0 rgba(0, 0, 0, 0.1);
    `}
`

const TabBar = React.memo(({ isAppview, showFixedTabBar, ...props }) => {
  const portalRef = useRef()

  const [mounted, setMounted] = useState(false)

  const transition = useTransition(showFixedTabBar && !isAppview, {
    from: { transform: 'translateY(-100%)' },
    enter: { transform: 'translateY(0%)' },
    leave: { transform: 'translateY(-100%)' },
    expires: 0
  })

  const tabBarId = 'fixed-tab-bar'

  useEffect(() => {
    let fixedTabBarDom = document.getElementById(tabBarId)

    if (R.isNil(fixedTabBarDom)) {
      const fixedTabBar = document.createElement('div')
      fixedTabBar.id = tabBarId
      document.body.appendChild(fixedTabBar)
      fixedTabBarDom = document.getElementById(tabBarId)
    }
    // ie11 doesn't support multiple params for add() method

    fixedTabBarDom.classList.add('rc-tabs')

    fixedTabBarDom.classList.add('rc-tabs-top')

    portalRef.current = fixedTabBarDom

    setMounted(true)
  }, [])

  return (
    <>
      {mounted
        ? createPortal(
            transition(
              (styles, item) =>
                item && (
                  <AnimatedDiv
                    style={styles}
                    $showFixedTabBar={showFixedTabBar}
                  >
                    <MaxWidth>
                      <StyledScrollableInkTabBar
                        nextIcon={<SvgIcon svg={<IconNext />} />}
                        prevIcon={<SvgIcon svg={<IconPrev />} />}
                        $showFixedTabBar={showFixedTabBar}
                        {...props}
                      />
                    </MaxWidth>
                  </AnimatedDiv>
                )
            ),
            portalRef.current
          )
        : null}
      {
        <ScrollableInkTabBar
          nextIcon={<SvgIcon svg={<IconNext />} />}
          prevIcon={<SvgIcon svg={<IconPrev />} />}
          css={`
            .rc-tabs-ink-bar {
              height: 4px;
              border-radius: 2px;
            }
          `}
          {...props}
        />
      }
    </>
  )
})

export default TabBar
